export const getSize = (padding: string) => {
  switch (padding) {
    case 'Small':
    case 'button--small':
      return 'small'
    case 'Medium':
    case 'button--medium':
      return 'medium'
    case 'Large':
    case 'button--large':
      return 'large'
    default:
      return 'default'
  }
}
export const getVariation = (variation: string) => {
  switch (variation) {
    case 'Primary':
    case 'button--primary':
      return 'primary'
    case 'Secondary':
    case 'button--secondary':
      return 'secondary'
    default:
      return 'primary'
  }
}
